<template>
  <div>
    <slot></slot>
  </div>
</template>
<script lang="ts">
import { computed, inject, provide } from 'vue'
import { registerComposableComponentSettings } from '../../../ComposableComponents'
import { ComposableDataListService } from '../ComposableDataListService'
import { FilterControlsService } from '../FilterControlsService'

registerComposableComponentSettings('ComposableDataListSearchWrapper', {
  label: 'ComposableDataListSearchWrapper',
  hasDefaultSlot: true,
  configColumns: {},
  defaultProps: {},
})

export default {
  name: 'ComposableDataListSearchWrapper',
  props: {},
  setup() {
    return {
      ComposableDataListServiceInstance: inject<ComposableDataListService>(
        'ComposableDataListServiceInstance',
      ),
    }
  },
  data() {
    return {
      FilterControlsService: null as FilterControlsService,
    }
  },
  created() {
    this.ComposableDataListServiceInstance.FilterControlsServiceInstance.appendModernFilter()
    this.FilterControlsService =
      this.ComposableDataListServiceInstance.FilterControlsServiceInstance
    // FilterControlsServiceをproviderする
    provide(
      'FilterControlsServiceInstance',
      computed(() => this.FilterControlsService),
    )
  },
}
</script>
